module.exports = __webpack_public_path__ + "static/Kwera_Credits_Jacob-54d7bf95df5dcd4e0182760eb36eb13e.png";